export default __webpack_public_path__ + "static/media/prisma.87dc4f58.png";